exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-project-dashboard-loading,\n.training-project-dashboard-not-found {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.training-project-dashboard-not-found {\n  font-size: 18px;\n  font-weight: 500;\n}\n.training-project-dashboard button.start-training-button:not(:disabled, .disabled-tooltip) {\n  background-color: green;\n  border-color: green;\n}\n", ""]);

// exports
